import { render, staticRenderFns } from "./SetUser.vue?vue&type=template&id=edcba96c&"
import script from "./SetUser.vue?vue&type=script&lang=js&"
export * from "./SetUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports